import { all, fork } from 'redux-saga/effects';
import { appSaga } from './app';

export function* watcherSaga() {
	yield all([fork(appSaga)]);
}
